/* Harper & Stone — footer accordions.
 *
 * The markup ships <details open> so every link is in the DOM without JS and
 * for crawlers. Below the desktop breakpoint the groups collapse, because an
 * always-expanded footer is an 800px wall of links with the newsletter buried
 * beneath it.
 */

const DESKTOP = matchMedia('(min-width: 64rem)');

class HsFooterAccordion extends HTMLElement {
  connectedCallback() {
    this.groups = [...this.querySelectorAll('[data-footer-accordion]')];
    if (!this.groups.length) return;

    this.sync = this.#sync.bind(this);
    this.#sync();
    DESKTOP.addEventListener('change', this.sync);
  }

  disconnectedCallback() {
    DESKTOP.removeEventListener('change', this.sync);
  }

  #sync() {
    const desktop = DESKTOP.matches;
    for (const group of this.groups) {
      // On desktop the summary is inert (pointer-events: none in CSS) and the
      // panel is always open. Below it, the user drives it.
      group.open = desktop;
      const summary = group.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', String(group.open));
    }
  }
}

if (!customElements.get('hs-footer-accordion')) customElements.define('hs-footer-accordion', HsFooterAccordion);
